import { Button } from './Button';
import './Modal.css';
import { ReactNode, useEffect } from 'react';

export const Modal: React.FC<{
   active?: boolean;
   hideCloseButton?: boolean;
   closeButtonFixed?: boolean;
   darkBackground?: boolean;
   transparent?: boolean;
   setActiveStatus?: (active: boolean) => void;
   noCorners?: boolean;
   className?: string;
   children?: ReactNode;
   onClose?: () => void;
   button?: {
      type: string;
      title: string;
      onClick: () => void;
      disabled?: boolean;
      loading?: boolean;
   };
}> = (props) => {
   const { onClose, active, darkBackground, hideCloseButton, children, setActiveStatus, closeButtonFixed, transparent, noCorners, className, button } = props;

   useEffect(() => {
      if (active) {
         document.body.classList.add('modal-open');
      } else {
         if (!document.querySelector('.modal-container')) {
            setTimeout(() => {
               document.body.classList.remove('modal-open');
            }, 200);
         }
      }
   }, [active]);

   const closeModal = () => {
      setActiveStatus !== undefined && setActiveStatus(false);
      onClose && onClose();
   };

   const clicOutside = (event: any) => {
      if (event.target.classList.contains('modal-container')) {
         closeModal();
      }
   };

   return (
      <>
         {active && (
            <div
               onClick={clicOutside}
               className={`${className} modal-container ${darkBackground ? 'background' : ''} ${noCorners ? 'no-corners' : ''} ${button ? 'has-bottom-button' : ''}`}>
               <div className={`window ${transparent ? 'transparent' : ''}`}>
                  <div className="p-4">
                     {children}
                     {hideCloseButton ||
                        (hideCloseButton === undefined && (
                           <button
                              className={`button-close ${closeButtonFixed ? 'fixed' : ''}`}
                              onClick={closeModal}>
                              <img
                                 src="/assets/icons/cross-icon.svg"
                                 alt="close"
                              />
                           </button>
                        ))}
                  </div>
                  {button && (
                     <Button
                        type={button.type as 'transparent' | 'green' | 'white' | 'green-big' | 'white-big' | 'close' | 'transparent-big'}
                        title={button.title}
                        onClick={button.onClick}
                        disabled={button.disabled}
                        loading={button.loading}
                     />
                  )}
               </div>
            </div>
         )}
      </>
   );
};
